import React from 'react';
import "./Projects.css";

export default function Projects() {


  return (<div>
    <div className='d-flex flex-column'>
      <div className='education-one my-4 justify-content-between d-flex flex-row'>

        <div className='d-flex flex-column new-one'>
          <span className='project-name'>
            Transit AR{""}
          </span>
          <span className='project-tech-stack'>
            Java, Kotlin, Jetpack{""}
          </span>
        </div>{""}
        <div>
          <span className='year-passed-out'>2018-2021</span>
        </div>


      </div>
      <div className='education-one my-4 justify-content-between d-flex flex-row'>

        <div className='d-flex flex-column new-one'>
          <span className='project-name'>
            React JS E commmerce{""}
          </span>
          <span className='project-tech-stack'>
            React, NodeJS{""}
          </span>
        </div>{""}
        <div>
          <span className='year-passed-out'>2018-2021</span>
        </div>


      </div>
      <div className='education-one my-4 justify-content-between d-flex flex-row'>

        <div className='d-flex flex-column new-one'>
          <span className='project-name'>
            React Typesript Transpiler Code Editor{""}
          </span>
          <span className='project-tech-stack'>
            React, Typescript{""}
          </span>
        </div>{""}
        <div>
          <span className='year-passed-out'>2018-2021</span>
        </div>


      </div>
    </div>
  </div>);
}